import { combineReducers } from "redux";
import { featureListReducer } from "./featureListReducer";

export const featureReducer = combineReducers({
  featureListReducer: featureListReducer
});
